import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import TableRow from "./TableRow";

export default function SortableRow({
  id,
  row,
  columns,
  onPopoverToggle,
  openPopover,
  handlePopoverAction,
  module,
  onRowChange,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition: transition ? transition : "transform 150ms ease",
  };

  return (
    <TableRow
      row={row}
      rowId={id}
      columns={columns}
      onPopoverToggle={onPopoverToggle}
      openPopover={openPopover}
      handlePopoverAction={handlePopoverAction}
      module={module}
      draggable={true}
      listeners={listeners}
      attributes={attributes}
      setNodeRef={setNodeRef}
      style={style}
      onRowChange={onRowChange}
    />
  );
}
